//This file was created to apply Redux
import React, { useState, useEffect } from "react"

import HomeContainer from "../Container/HomeContainer2"
import TeacherProfile from "../Profile/TeacherProfile.redux"

// import { createUserObject } from "../Profile/profile.utils"
import Spinner from "../../Components/Spinner/Spinner"

// import ProfileBox from "../../Components/ProfileBox/ProfileBox";

//Yuan:redux
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
//Yuan-selector
import { selectUserDetails } from "../../redux/homePage/homePage.selectors"
import { API } from "../../API"
import Auth from "../../Auth/Auth"

const PreviewProfile3 = (props) => {
  // const userObject = createUserObject(user)
  const [qualificationList, setQualificationList] = useState()
  const [user, setUser] = useState("")
  // const [selectedList, setSelectedList] = useState([])

  const handleUser = async () => {
    if (!window.localStorage.token || !Auth.authenticated) {
      const path = {
        pathname: "/login",
      }
      props.history.push(path)
    } else {
      const result = await API.getUserSafeData()
      setUser(result.data.user)
      return result.data.user
    }
  }

  const handleQualification = () => {
    API.getQualificationList().then(result => {
      const qualifications = result?.data?.data
      setQualificationList(qualifications)
    })
  }

  useEffect(() => {
    handleUser()
    handleQualification()
  }, [])

  if (user) {
    return (
      <HomeContainer
        user={user}
        isViewAsTeacher={false}
        footer={null}
        isShowWhereby={true}
        tabProfileActive={true}
      >
        {qualificationList?.length && <TeacherProfile
          user={user}
          isShowFooter={false}
          // userObject={userObject}
          seeResume={true}
          // selectedItem={selectedList}
          qualifications={qualificationList}
        />}
      </HomeContainer>
    )
  }
  // else return <div>Loading</div>;
  else return <Spinner />
}

const mapStateToProps = createStructuredSelector({
  userOnRoot: selectUserDetails,
})

export default connect(mapStateToProps)(PreviewProfile3)
